























































import Vue, { PropType } from "vue";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";
import { ElementColors } from "@/common/theme/ElementColors";
import { DateTime } from "luxon";
import { PPBookings } from "@/picking-portal/models/PPBookings.ts";
import { storeService } from "@/common/services/StoreService";

export default Vue.extend({
  name: "PPSlotBookingsItem",
  props: {
    bookedSlot: { type: Object as PropType<PPBookings>, required: true },
    storeId: { type: String, required: true },
  },
  data() {
    return {
      Colors: ElementColors,
      isUrgent: false,
      time: "",
    };
  },
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.isUrgent = DateTime.now() > DateTime.fromISO(this.bookedSlot.start).minus({ hour: 1 });
    this.time = DateTime.fromISO(this.bookedSlot.start, {
      setZone: true,
      zone: this.getStoreTimeZone(),
    }).toLocaleString(DateTime.TIME_SIMPLE);
  },
  methods: {
    cardClicked(): void {
      this.$router.push({
        name: RouteInfoMap.get(Paths.ClickAndCollectOrders)?.name,
        query: {
          storeId: this.storeId.toString(),
          from: this.bookedSlot.start,
          to: this.bookedSlot.end,
        },
      });
    },
    getStoreTimeZone(): string {
      return storeService.getStoreTimeZone(this.storeId) ?? DateTime.local().zone.name;
    },
  },
});
